import { TJsonQuery } from '../../../../../packages/JsonQuery';

interface IParams {
  totalOffers: number;
  jsonQuery: TJsonQuery;
  mlSearchSessionGuid: string | null;
}

export const prepareGaExtra = ({ totalOffers, jsonQuery, mlSearchSessionGuid }: IParams) => {
  return JSON.stringify({
    mlSearchSessionGuid,
    sc: jsonQuery,
    offersQty: totalOffers,
  });
};
